import { render, staticRenderFns } from "./courseSelectorRootCategory.vue?vue&type=template&id=558e6f4e&scoped=true&"
import script from "./courseSelectorRootCategory.vue?vue&type=script&lang=js&"
export * from "./courseSelectorRootCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e6f4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VExpandTransition,VSheet})
